<div class="page-container">
    <app-header [title]="'settings.company-logo.header' | translate" [menuService]="settingsMenuService"> </app-header>

    <div class="ui segment" aria-labelledby="company-logo-header" role="group">
        <app-segment-header
            id="company-logo-header"
            [title]="'settings.company-logo.sectionHeader' | translate"
        ></app-segment-header>
        <div class="app-grid">
            <div class="columns-6">
                <p>{{ 'settings.company-logo.description' | translate }}</p>
                <ui-tip>
                    {{ 'settings.company-logo.tipMessage' | translate }}
                </ui-tip>
            </div>
            <div class="columns-6">
                <app-company-logo-uploader></app-company-logo-uploader>
            </div>
        </div>
    </div>
</div>
